import { PgaPolicy } from "src/shared/models/pga-policy.model";

export class RentalPolicy extends PgaPolicy {}
